<template>
  <v-row class="no-gutters">
    <div class="form-container" :class="{ selected: form === 'login' }">
      <div
        v-show="form === 'login'"
        class="animate__animated"
        :class="{ animate__fadeIn: form === 'login' }"
      >
        <v-form ref="formLogin">
          <v-card max-width="500" class="mx-auto bg-transparent" elevation="0">
            <v-card-text class="text-center">
              <h2
                class="mt-8 mb-12 text---primary title-4 d-flex align-center justify-center"
              >
                {{ lang.actions.logInTo }}
                <img
                  class="mx-2 cursor-pointer logo-width"
                  @click="$router.push('/')"
                  alt="Good Casper logo"
                  :src="require(`../assets/images/logo/good_casper_black.png`)"
                />
              </h2>
            </v-card-text>
            <v-card-text>
              <!-- <div class="d-flex align-center">
                <v-img
                  max-width="30"
                  class="mr-1"
                  :alt="`Flag ${$store.state.lang}`"
                  :lazy-src="require('../assets/images/lazy-loading.png')"
                  :src="
                    require(`../assets/images/flags/${$store.state.lang}.png`)
                  "
                ></v-img>
                <v-select
                  :items="languages"
                  v-model="language"
                  :label="lang.fields.language"
                ></v-select>
              </div> -->
              <v-text-field
                v-model="login.mail"
                :rules="[rules.required, rules.email]"
                :label="lang.fields.username"
                prepend-icon="mdi-account"
                @keyup.enter="loginSubmit()"
              ></v-text-field>
              <v-text-field
                type="password"
                v-model="login.password"
                :rules="[rules.required]"
                :label="lang.fields.password"
                prepend-icon="mdi-key"
                @keyup.enter="loginSubmit()"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="d-flex flex-column">
              <v-btn
                x-large
                class="with-radius btn-bg"
                elevation="0"
                block
                @click="loginSubmit()"
                >{{ lang.actions.login }}</v-btn
              >
              <v-btn
                v-if="showResendActivationLink"
                class="with-radius btn-bg mt-4 px-4"
                elevation="0"
                @click="resendActivationLink()"
                >Resend activation link</v-btn
              >
            </v-card-actions>
            <v-card-text class="pb-0 pt-2">
              <router-link
                to="/ForgotPassword"
                class="forgot-password-link d-block text-center text---primary"
                >{{ lang.login.forgotPassword }}</router-link
              >
            </v-card-text>
            <v-card-text class="pb-0 pt-0 text-center show-on-mobile">
              <p class="text---primary caption mb-2 font-weight-bold">
                {{ lang.login.or }}
              </p>
              <v-btn
                @click="setFormState('signup')"
                outlined
                block
                x-large
                class="with-radius text---primary light"
                >{{ lang.actions.signUp }}</v-btn
              >
            </v-card-text>
          </v-card>
        </v-form>
      </div>
      <div
        v-show="form !== 'login'"
        class="animate__animated"
        :class="{ animate__fadeIn: form !== 'login' }"
      >
        <v-row>
          <v-col class="col-12" v-if="!signUpRequestSent">
            <v-form ref="formSignUp" class="formSignUp">
              <v-card
                max-width="700"
                class="mx-auto bg-transparent"
                elevation="0"
              >
                <v-card-text class="text-center pb-0">
                  <h2
                    class="mt-md-8 mb-md-12 text---primary title-4 d-flex align-center justify-center"
                  >
                    {{ lang.actions.signUpTo }}
                    <img
                      @click="$router.push('/')"
                      alt="Good Casper logo"
                      class="mx-2 cursor-pointer logo-width"
                      :src="
                        require(`../assets/images/logo/good_casper_black.png`)
                      "
                    />
                  </h2>
                </v-card-text>
                <v-card-text class="px-0">
                  <v-row class="no-gutters">
                    <v-col class="col-12 col-md-6 mb-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-account"
                        v-model="signUp.name"
                        :rules="[rules.required]"
                        :label="lang.fields ? lang.fields.name : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-6 my-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-account"
                        v-model="signUp.lastName"
                        :rules="[rules.required]"
                        :label="lang.fields.surname"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-6 my-0 py-3">
                      <v-dialog
                        ref="dialogBirth"
                        v-model="menu"
                        :return-value.sync="signUp.dateOfBirth"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="signUp.dateOfBirth"
                            :label="lang.fields.birthDate"
                            :rules="[rules.required]"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            dense
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="signUp.dateOfBirth" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialogBirth.save(signUp.dateOfBirth)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col class="col-12 col-md-6 my-0 py-0 d-flex">
                      <v-radio-group
                        :rules="[rules.required]"
                        v-model="signUp.gender"
                        row
                      >
                        <v-radio
                          :ripple="false"
                          :label="lang.fields.other"
                          value="Other"
                        ></v-radio>
                        <v-radio
                          :ripple="false"
                          :label="lang.fields.male"
                          value="Male"
                        ></v-radio>
                        <v-radio
                          :ripple="false"
                          :label="lang.fields.female"
                          value="Female"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col class="col-12 col-md-4 my-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-cellphone"
                        v-model="signUp.phone"
                        :label="lang.fields.phone"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-4 my-0 py-0">
                      <v-autocomplete
                        :items="countriesDropdown"
                        prepend-icon="mdi-earth"
                        v-model="signUp.country"
                        :label="lang.fields.country"
                        :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-md-4 my-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-city"
                        v-model="signUp.city"
                        :rules="[rules.required]"
                        :label="lang.fields.city"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 my-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-email"
                        v-model="signUp.email"
                        :rules="[rules.required, rules.email]"
                        :label="lang.fields.mail"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-6 my-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-key"
                        type="password"
                        v-model="signUp.password"
                        :rules="[rules.required]"
                        :label="lang.fields.password"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-6 my-0 py-0">
                      <v-text-field
                        prepend-icon="mdi-key"
                        type="password"
                        v-model="signUp.passwordConfirmed"
                        :rules="[rules.required, passwordRules.passwordMatch]"
                        :label="lang.fields.confirmPassword"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 mb-0 py-0">
                      <v-checkbox
                        :rules="[rules.required]"
                        :label="lang.fields ? lang.fields.name : ''"
                        color="primary"
                        :value="true"
                        hide-details
                        :ripple="false"
                      >
                        <template v-slot:label>
                          <div>
                            {{ lang.general.iAgreeTo }}
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <a
                                  target="_blank"
                                  href="/TermsAndConditions"
                                  @click.stop
                                  v-on="on"
                                >
                                  {{
                                    lang.general.termsAndConditionsAndPrivacy
                                  }}
                                </a>
                              </template>
                              {{ lang.general.openNewTab }}
                            </v-tooltip>
                            Good Casper
                          </div>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pb-4 d-flex flex-wrap">
                  <v-card-text class="px-0 pb-0">
                    <v-btn
                      class="with-radius btn-bg"
                      x-large
                      elevation="0"
                      block
                      @click="signUpSubmit()"
                      >CREATE ACCOUNT</v-btn
                    >
                  </v-card-text>
                  <v-card-text class="pb-4 text-center show-on-mobile px-0">
                    <p class="text---primary caption mb-3 font-weight-bold">
                      {{ lang.login.or }}
                    </p>
                    <v-btn
                      @click="setFormState('login')"
                      outlined
                      block
                      x-large
                      class="with-radius text---primary light"
                      >{{ lang.actions.login }}</v-btn
                    >
                  </v-card-text>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
          <v-col class="col-12" v-else>
            <div>
              <v-card elevation="0" class="bg-transparent">
                <v-card-text
                  class="text-center animate__animated pb-0"
                  :class="{ animate__zoomInDown: signUpRequestSent }"
                >
                  <v-icon class="display-4 text---primary"
                    >mdi-account-check-outline</v-icon
                  >
                </v-card-text>
                <v-card-text
                  class="text-center animate__animated"
                  :class="{ animate__zoomInDown: signUpRequestSent }"
                >
                  <div class="d-flex justify-center">
                    <img
                      width="260"
                      class="cursor-pointer pb-8"
                      @click="$router.push('/')"
                      alt="Good Casper logo"
                      :src="
                        require(`../assets/images/logo/good_casper_black.svg`)
                      "
                    />
                  </div>
                  <p
                    class="p-subtitle text---primary"
                    v-html="lang.signUp.w2"
                  ></p>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="text-container" :class="{ selected: form === 'login' }">
      <div v-if="form === 'login'">
        <h2 class="title-2">{{ lang.login.helloFriend }}</h2>
        <p class="p-subtitle" v-html="lang.login.w1"></p>
        <v-btn
          class="with-radius"
          x-large
          outlined
          elevation="0"
          @click="setFormState('signup')"
          >{{ lang.actions.signUp }}</v-btn
        >
      </div>
      <div v-else>
        <h2 class="title-2">{{ lang.login.welcomeBack }}</h2>
        <p class="p-subtitle" v-html="lang.login.w2"></p>
        <v-btn
          class="with-radius"
          x-large
          outlined
          elevation="0"
          @click="setFormState('login')"
          >{{ lang.actions.login }}</v-btn
        >
      </div>
    </div>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "../plugins/helpers";
import "animate.css";
export default {
  name: "Login",
  data() {
    return {
      form: "login",
      date: null,
      menu: false,
      signUpRequestSent: false,
      showResendActivationLink: false,
      passwordRules: {
        passwordMatch: () =>
          this.signUp.password === this.signUp.passwordConfirmed ||
          this.lang.rules.passwordMustMatch,
      },
    };
  },
  computed: {
    countriesDropdown() {
      return helpers.countries().map((el) => el.text);
    },
    language: {
      get() {
        return localStorage.getItem("lang") || this.$store.state.lang;
      },
      set(value) {
        localStorage.setItem("lang", value);
        this.$store.state.lang = value;
      },
    },
    languages() {
      return helpers.languageDropdown();
    },
    ...mapGetters(["rules", "login", "signUp"]),
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    resendActivationLink() {
      this.$store.dispatch("user/resendActivationAccountLink", this.login.mail);
      this.showResendActivationLink = false;
    },
    setFormState(formState) {
      this.form = formState;
      this.signUpRequestSent = false;
      if (formState !== "login") {
        document.getElementsByClassName("form-container")[0].style.left =
          window.innerWidth < 1050 ? "0" : "40%";
        document.getElementsByClassName("text-container")[0].style.right =
          "60%";

        document.title = "Good Casper - Sign Up";
      } else {
        document.getElementsByClassName("form-container")[0].style.left = "0";
        document.getElementsByClassName("text-container")[0].style.right = "0";

        document.title = "Good Casper - Login";
      }
      this.resetSignupForm();
      this.resetLoginForm();
      this.$refs.formLogin.resetValidation();
      if (this.$refs.formSignUp) {
        this.$refs.formSignUp.resetValidation();
      }
    },
    loginSubmit() {
      if (this.$refs.formLogin.validate()) {
        this.$store
          .dispatch("user/login", {
            mail: this.login.mail,
            password: this.login.password,
          })
          .then(() => {
            this.resetLoginForm();
            this.showResendActivationLink = false;
          })
          .catch((error) => {
            if (error.response?.data == "activateAccount") {
              this.showResendActivationLink = true;
            } else {
              this.showResendActivationLink = false;
            }
          });
      }
    },
    resetLoginForm() {
      this.login.mail = "";
      this.login.password = "";
    },
    resetSignupForm() {
      this.signUp.name = "";
      this.signUp.email = "";
      this.signUp.gender = "";
      this.signUp.lastName = "";
      this.signUp.dateOfBirth = "";
      this.signUp.password = "";
      this.signUp.passwordConfirmed = "";
      this.signUp.phone = "";
      this.signUp.country = "";
      this.signUp.city = "";
    },
    signUpSubmit() {
      if (this.$refs.formSignUp.validate()) {
        this.$store.dispatch("user/signup", this.signUp).then(() => {
          this.signUpRequestSent = true;
        });
      }
    },
  },
  mounted() {
    this.resetLoginForm();
    this.resetSignupForm();
    this.$store.dispatch("user/logout");
    this.setFormState(this.$route.query.state || "login");
  },
};
</script>

<style lang="scss">
.animate__animated.animate__fadeIn {
  --animate-duration: 1s;
}
.animate__animated.animate__zoomInDown {
  --animate-duration: 1.5s;
}
.forgot-password-link {
  text-decoration: underline !important;
}
.formSignUp {
  width: 100%;
}
</style>

<style scoped lang="scss">
.logo-width {
  width: 200px;
  @media screen and (max-width: 600px) {
    width: 130px;
  }
}
.logo-text {
  cursor: pointer;
  color: #494848;
}
</style>